/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * Recipient payment method
 */
export type CreateManualInvoiceRequestRecipientPaymentMethod = typeof CreateManualInvoiceRequestRecipientPaymentMethod[keyof typeof CreateManualInvoiceRequestRecipientPaymentMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateManualInvoiceRequestRecipientPaymentMethod = {
  ACH: 'ACH',
  check: 'check',
  credit: 'credit',
  cash: 'cash',
  stripe: 'stripe',
} as const;
